import * as React from 'react';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';
import { Row, Col, Tabs } from 'antd';
import autobind from 'autobind-decorator';
import { connect } from "react-redux";

import { TourItineraryDateGeneralTab } from 'src/app/products/tour-itineraries/tour-itinerary-date/form/parts/tour-itinerary-date-general-tab';
import { TourItineraryDatePaxTab } from 'src/app/products/tour-itineraries/tour-itinerary-date/form/parts/tour-itinerary-date-pax-tab';
import { TourItineraryDatePriceTab } from 'src/app/products/tour-itineraries/tour-itinerary-date/form/parts/tour-itinerary-date-price-tab';
import { ConfigurationService } from 'src/core/services/configuration.service';

interface PropsFromState {
	products: TourItineraryProductItem[];
}

interface Props extends ComponentViewProps<TourItineraryDateItem> {
	mode: ControlMode;
	itinerary: TourItineraryItem;
}

interface State {
	isAgeBandValid: boolean;
	isOccupancyValid: boolean;
}

@observer
class TourItineraryDateFormView extends React.Component<Props & PropsFromState, State> {
	@resolve
	private configService: ConfigurationService;

	constructor(props: Readonly<Props & PropsFromState>) {
		super(props);

		this.state = {
			isAgeBandValid: props.model.dynamicProperties.ageBands.length !== 0,
			isOccupancyValid: true
		};
	}

	@autobind
	private handleChangeAgeBandValidity(value: boolean): void {
		this.setState({
			isAgeBandValid: value
		});
	}

	@autobind
	private handleChangeOccupancyValidity(value: boolean): void {
		this.setState({
			isOccupancyValid: value
		});
	}

	@autobind
	private getAgeBandTag(item: AgeBandItem): string {
		return item.type === 0
			? 'a'
			: item.type === 1
				? 'c'
				: 'i';
	}

	render(): React.ReactNode {
		if (!this.configService.configuration) {
			return null;
		}

		const { model } = this.props;
		const { isAgeBandValid, isOccupancyValid } = this.state;
		const isDisabledPriceTab = model.dateFrom == null || !isAgeBandValid || !isOccupancyValid;

		return (
			<Row>
				<Col xs={24}>
					<div className="card p-3">
						<Tabs>
							<Tabs.TabPane
								tab="General Information"
								key="general">
								<TourItineraryDateGeneralTab
									{...this.props}
								/>
							</Tabs.TabPane>
							<Tabs.TabPane
								tab="Pax"
								key="pax"
								disabled={model.dateFrom == null}>
								<TourItineraryDatePaxTab
									getAgeBandTag={this.getAgeBandTag}
									onChangeAgeBandValidity={this.handleChangeAgeBandValidity}
									onChangeOccupancyValidity={this.handleChangeOccupancyValidity}
									{...this.props}
								/>
							</Tabs.TabPane>
							<Tabs.TabPane
								tab="Price"
								key="price"
								disabled={isDisabledPriceTab}>
								<TourItineraryDatePriceTab
									isDisabled={isDisabledPriceTab}
									getAgeBandTag={this.getAgeBandTag}
									languageCode={this.configService.configuration.defaultLanguage}
									{...this.props}
								/>
							</Tabs.TabPane>
						</Tabs>
					</div>
				</Col>
			</Row>
		);
	}
}

const mapStateToProps = (
	state: IApplicationState,
	props: Props
): PropsFromState => ({
	products: (state.otherLoadedEntities.find(e => e.entity == props.itinerary.entity) as TourItineraryItem).products,
});

const connected = connect(mapStateToProps)(TourItineraryDateFormView);
export { connected as TourItineraryDateFormView };



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/tour-itinerary-date/form/tour-itinerary-date-form.view.tsx